import { render, staticRenderFns } from "./ReplacementList.html?vue&type=template&id=39a54b7e&external"
import script from "./ReplacementList.ts?vue&type=script&lang=ts&external"
export * from "./ReplacementList.ts?vue&type=script&lang=ts&external"
import style0 from "./ReplacementList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports